import { once } from './utils'

function findModal(selector) {
  return document.querySelector(selector) ||
    document.querySelector(`#${selector}`)
}

function closeModal(el) {
  if (!el) { return }

  once(el, 'animationend', () => {
    el.classList.remove("is-active")
    el.classList.remove("modal--hide-animation")
  })
  el.classList.add("modal--hide-animation")
  el.classList.remove("modal--show-animation")

  const event = new CustomEvent("modal:close")
  el.dispatchEvent(event)
}

document.addEventListener("turbo:before-morph-attribute", e => {
  if (e.target.matches(".modal.is-active") && e.detail.attributeName == "class") {
    e.preventDefault()
  }
})

document.addEventListener('click', e => {
  const modalTarget = e.target.closest("[data-modal]")
  if (modalTarget) {
    // allow turbo frame links to still load
    if (!modalTarget.dataset.turboFrame) {
      e.preventDefault()
    }

    const modal = findModal(modalTarget.getAttribute("data-modal"))
    once(modal, 'animationend', () => modal.classList.remove("modal--show-animation"))
    modal.classList.add("is-active", "modal--show-animation")
    modal.classList.remove("modal--hide-animation")

    if (e.target.dataset.modalSrc) {
      modal.querySelector("turbo-frame[src]").src = e.target.dataset.modalSrc
    }

    const event = new CustomEvent("modal:open", { detail: { target: modalTarget } })
    modal.dispatchEvent(event)
  }
})

document.addEventListener('click', e => {
  if (e.target.matches(".modal-close, .modal-background, [data-behavior~=modal-close]")) {
    // don't prevent a form submission for targets that are associated with a form
    if (!e.target.form) {
      e.preventDefault()
    }
    const modal = e.target.closest(".modal")
    closeModal(modal)
  }
})

// close via esc key
document.addEventListener('keydown', event => {
  const e = event || window.event

  if (e.keyCode === 27) {
    document.querySelectorAll('.modal').forEach(el => {
      if (el.matches(".focussed")) { return }
      closeModal(el)
    })
  }
})
